import React, {FC, useEffect, useState} from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import BannersLinkRewriterService from "../../services/BannerLinkRewriterService";
import ModalAgree from "../ModalAgree/ModalAgree";

interface BannersLinkRewriterProps {
    handleAgreement: (e: boolean) => void;
}


const domainValidationRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[^\s?#<>]*)?$/;

const validationSchema = Yup.object().shape({
    domain: Yup.string()
        .required("Required field")
        .test(
            "no-protocol",
            "You cannot use http:// or https://",
            (value) => value ? !/^https?:\/\//i.test(value) : true
        )
        .test(
            "no-params-or-hash",
            "Cannot use parameters or anchors (?, #)",
            (value) => value ? !/[?#]/.test(value) : true
        )
        .test(
            "valid-format",
            "Invalid domain format",
            (value) => value ? domainValidationRegex.test(value) : false
        )
        .test(
            "no-script-tags",
            "It is forbidden to insert scripts or HTML tags",
            (value) => value ? !/<[^>]*script[^>]*>/i.test(value) && !/<[^>]+>/.test(value) : true
        ),
});

const BannersLinkRewriter: FC<BannersLinkRewriterProps> = (props) => {

    const [openModalAgree, setOpenModalAgree] = useState<boolean>(false);
    const [linkToRewrite, setLinkToRewrite] = useState<string>('');



    const rewriteBannersLink = async (link:string) => {
        const response = await BannersLinkRewriterService.rewriteBannersLink(link);
    }

    const getUserChoice = (status: boolean) => {
        if (status) {
            rewriteBannersLink(linkToRewrite);
        }
        setOpenModalAgree(false);
        props.handleAgreement(false);
    };



    useEffect(() => {

    }, []);


    return (

        <>

            {openModalAgree ? <ModalAgree handleAgreement={getUserChoice} /> : false}
            <div className="modal show"></div>

            <div className="modal show" role="dialog">
                <div
                    className="modal-dialog w-75 min-vh-100 d-flex flex-column align-items-center justify-content-center"
                    role="document"
                >
                    <div className="modal-content p-4">
                        <h4>Change link on all banners</h4>

                        <Formik
                            initialValues={{ domain: "" }}
                            validationSchema={validationSchema}
                            onSubmit={(values) => {
                                setOpenModalAgree(true);
                                setLinkToRewrite(values.domain);
                            }}
                        >
                            {({ isSubmitting }) => (
                                <Form>
                                    <div className="form-group mb-3">
                                        <label htmlFor="domain" className='mb-2'>New link</label>
                                        <Field
                                            type="text"
                                            name="domain"
                                            className="form-control"
                                            placeholder="example.com або sub.example.com/path"
                                        />
                                        <ErrorMessage
                                            name="domain"
                                            component="div"
                                            className="text-danger mt-1"
                                        />
                                    </div>
                                    <div className="d-flex justify-content-center w-100">
                                        <button
                                            type="submit"
                                            className="btn btn-success rounded-md mx-2 w-25"
                                            disabled={isSubmitting}
                                        >
                                            Submit
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-danger rounded-md w-25"
                                            onClick={() => props.handleAgreement(false)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>

        </>

    );
};

export default BannersLinkRewriter;
